import { render, staticRenderFns } from "./HorseAjoutBeta.vue?vue&type=template&id=fb842fb8&"
import script from "./HorseAjoutBeta.vue?vue&type=script&lang=js&"
export * from "./HorseAjoutBeta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports